<template>
  <div class="w-full h-full rounded-lg flex flex-col gap-2">
    <!-- Tab Navigation -->
    <div class="flex gap-2 border-b" style="border-color: var(--glass-border, rgba(255,255,255,0.15))">
      <button
        @click="setActiveTab('capa')"
        :class="[
          'tab-btn',
          activeTab === 'capa' ? 'tab-btn-active' : 'tab-btn-inactive'
        ]"
      >
        <i class="fa-solid fa-image"></i>
        Capas
      </button>
      <button
        @click="setActiveTab('template')"
        :class="[
          'tab-btn',
          activeTab === 'template' ? 'tab-btn-active' : 'tab-btn-inactive'
        ]"
      >
        <i class="fa-solid fa-file-alt"></i>
        Templates
      </button>
    </div>

    <!-- Tab Content -->
    <div class="flex-1 overflow-auto scrollbar-tema">
      <Capa v-if="activeTab === 'capa'" />
      <Templates v-if="activeTab === 'template'" />
    </div>
  </div>
</template>

<script>
import permissionMixin from "@/permissionMixin.js";
import Templates from "@/components/capa_template/template/template.vue";
import Capa from "@/components/capa_template/capa/capa.vue";

export default {
  mixins: [permissionMixin],
  name: "app-capa-template-manager",
  components: {
    Templates,
    Capa,
  },
  data() {
    return {
      baseURl: process.env.VUE_APP_URL_BASE,
      activeTab: 'capa',
    };
  },
  created() {
    // Restore active tab from query parameter
    const tabFromQuery = this.$route.query.tab;
    if (tabFromQuery === 'template' || tabFromQuery === 'capa') {
      this.activeTab = tabFromQuery;
    }
  },
  methods: {
    setActiveTab(tab) {
      this.activeTab = tab;
      // Update URL query parameter without reloading
      this.$router.replace({ 
        query: { ...this.$route.query, tab } 
      }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.scrollbar-tema {
  scrollbar-width: thin;
  scrollbar-color: var(--scroll) transparent;
}

.tab-btn {
  padding: 0.3rem 0.5rem;
  border-radius: 0.375rem 0.375rem 0 0;
  font-weight: 600;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: none;
  cursor: pointer;
  font-size: 0.875rem;
}

.tab-btn-active {
  background-color: var(--button);
  color: var(--iconCima);
  border-bottom: 2px solid var(--button);
}

.tab-btn-inactive {
  background-color: var(--secundary, rgba(255, 255, 255, 0.05));
  color: var(--glass-muted, rgba(255, 255, 255, 0.6));
  border-bottom: 2px solid transparent;
}

.tab-btn-inactive:hover {
  background-color: var(--fundoComponente, rgba(255, 255, 255, 0.1));
  color: var(--text);
}
</style>
